import { useOnceEffect } from "@core/hooks/use-once-effect";
import styled from "@emotion/styled";
import { LoadingContainer } from "@ui/components/common/loading-container";
import { OnfidoComponentId, useOnfido } from "@ui/pages/register/steps/hooks/use-onfido";
import { physioMeTabletBreakpoint } from "@ui/style";
import React from "react";

interface RegisterOnfidoIdentityVerificationProps {
	onComplete: () => void;
}

export const RegisterOnfidoIdentityVerificationStep = ({
	onComplete,
}: RegisterOnfidoIdentityVerificationProps): JSX.Element => {
	const { initOnfido, loading } = useOnfido();

	useOnceEffect(() => initOnfido(onComplete));

	return (
		<Container>
			{loading && <LoadingContainer />}
			<OnfidoComponent id={OnfidoComponentId} loading={loading} />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	min-width: 50%;
`;

const OnfidoComponent = styled.div<{ loading: boolean }>`
	#onfido-sdk {
		max-width: none;
		max-height: none;

		@media ${physioMeTabletBreakpoint} {
			min-height: 600px;
			height: auto;
		}
	}
`;